import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type PartsDeliveryCancelMutationVariables = Types.Exact<{
  partsDeliveryId: Types.Scalars['Int']['input'];
  reason?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PartsDeliveryCancelMutation = { __typename?: 'mutation_root', partsDeliveryCancel?: { __typename?: 'PartsDeliveryCancelOutput', partsDeliveryId: number, deliveryStatus: string, canceledAt?: string | null, cancelationReason?: string | null } | null };


export const PartsDeliveryCancelDocument = gql`
    mutation partsDeliveryCancel($partsDeliveryId: Int!, $reason: String) {
  partsDeliveryCancel(partsDeliveryId: $partsDeliveryId, reason: $reason) {
    partsDeliveryId
    deliveryStatus
    canceledAt
    cancelationReason
  }
}
    `;
export type PartsDeliveryCancelMutationFn = Apollo.MutationFunction<PartsDeliveryCancelMutation, PartsDeliveryCancelMutationVariables>;

/**
 * __usePartsDeliveryCancelMutation__
 *
 * To run a mutation, you first call `usePartsDeliveryCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartsDeliveryCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partsDeliveryCancelMutation, { data, loading, error }] = usePartsDeliveryCancelMutation({
 *   variables: {
 *      partsDeliveryId: // value for 'partsDeliveryId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function usePartsDeliveryCancelMutation(baseOptions?: Apollo.MutationHookOptions<PartsDeliveryCancelMutation, PartsDeliveryCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartsDeliveryCancelMutation, PartsDeliveryCancelMutationVariables>(PartsDeliveryCancelDocument, options);
      }
export type PartsDeliveryCancelMutationHookResult = ReturnType<typeof usePartsDeliveryCancelMutation>;
export type PartsDeliveryCancelMutationResult = Apollo.MutationResult<PartsDeliveryCancelMutation>;
export type PartsDeliveryCancelMutationOptions = Apollo.BaseMutationOptions<PartsDeliveryCancelMutation, PartsDeliveryCancelMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/partsDeliveryCancel.mutation.gql}
 */
export async function partsDeliveryCancel(
  variables: PartsDeliveryCancelMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<PartsDeliveryCancelMutation['partsDeliveryCancel']>
export async function partsDeliveryCancel(
  variables: PartsDeliveryCancelMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<PartsDeliveryCancelMutation>
export async function partsDeliveryCancel(
  variables: PartsDeliveryCancelMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<PartsDeliveryCancelMutation['partsDeliveryCancel'] | PartsDeliveryCancelMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<PartsDeliveryCancelMutation>(
    PartsDeliveryCancelDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.partsDeliveryCancel
}